<template>
  <div class="user-orders">
    <navbar left-text show-home title="订单管理"></navbar>
    <div class="nav-list-bar">
      <ul class="order-nav">
        <li
          :class="{ current: currentType === type.value }"
          :key="index"
          v-for="(type, index) in orderTypes"
        >
          <button @click="switchType(type.value)">{{ type.name }}</button>
        </li>
      </ul>
    </div>
    <div class="nav-list-bar2" v-if="currentType === 'mall'">
      <ul class="order-nav">
        <li
          :class="{ current: current === index }"
          :key="index"
          v-for="(nav, index) in navList"
        >
          <button @click="switchTab(index)">{{ nav }}</button>
        </li>
      </ul>
    </div>
    <div class="nav-container-mall" v-if="currentType === 'mall'">
      <component :is="componentId"></component>
    </div>
    <div class="nav-container-seckill" v-else-if="currentType === 'seckill'">
      <OrderAllItem></OrderAllItem>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Navbar from '../components/NavBar'
import OrderAllItem from '../components/orderStatus/orderAllItem.vue'
import AllOrders from '../components/orderStatus/AllOrders'
import OrderToBePaid from '../components/orderStatus/OrderToBePaid'
import AwaitingShipmentOrder from '../components/orderStatus/AwaitingShipmentOrder'
import OrderToBeReceived from '../components/orderStatus/OrderToBeReceived'
import CouponCenter from '../components/orderStatus/MyCardVoucher'
export default {
  name: 'orders',
  components: {
    Navbar,
    OrderAllItem,
    AllOrders,
    OrderToBePaid,
    AwaitingShipmentOrder,
    OrderToBeReceived,
    CouponCenter
  },
  data () {
    return {
      orderTypes: [
        {
          name: '商城订单',
          value: 'mall'
        },
        {
          name: '秒杀订单',
          value: 'seckill'
        }
      ],
      navList: ['全部订单', '待付款', '待收货', '已购卡券'],
      orderList: []
    }
  },
  computed: {
    ...mapState('order', {
      current: state => state.orderNavCurrent,
      currentType: state => state.orderTypeCurrent
    }),
    componentId () {
      switch (this.current) {
        case 0:
          return AllOrders
        case 1:
          return OrderToBePaid
        // case 2:
        //   return AwaitingShipmentOrder
        case 2:
          return OrderToBeReceived
        case 3:
          return CouponCenter
        default:
          return AllOrders
      }
    }
  },
  created () {
  },
  methods: {
    ...mapMutations('order', [
      'changeOrderNavCurent',
      'changeOrderTypeCurent'
    ]),
    switchTab (i) {
      this.changeOrderNavCurent(i)
    },
    switchType (i) {
      this.changeOrderTypeCurent(i)
    }
  }
}
</script>

<style lang="less" scoped>
.goHome {
  width: 0.58rem;
  height: 0.58rem;
  background: url("../assets/img/share.png") center no-repeat;
  background-size: 100%;
}
.user-orders {
  //   /deep/ .nav-bar-wrapper{
  //   background-color:#000 ;
  //   color: #fff;
  // }
}
.nav-list-bar {
  position: fixed;
  top: 0.88rem;
  left: 0;
  right: 0;
  z-index: 9;
  background-color: #f8f8f8;
}
.nav-list-bar2 {
  position: fixed;
  top: 1.68rem;
  left: 0;
  right: 0;
  z-index: 9;
  background-color: #f8f8f8;
}
.order-nav {
  height: 0.8rem;
  padding: 0 0.4rem;
  background-color: #fff;
  margin-bottom: 0.1rem;
  .flex-between;
  font-size: @fz28;
  color: @base;
  li {
    flex: 1;
    height: 100%;
    button {
      width: 100%;
      height: 100%;
    }
  }
  .current {
    position: relative;
    &::after {
      position: absolute;
      content: "";
      width: 0.8rem;
      height: 0.06rem;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      background-color: #2d2d3e;
      // background-color: #ff5172;
    }
  }
}
.nav-container-mall {
  padding-top: 1.8rem;
}
.nav-container-seckill {
  padding-top: 0.8rem;
}
</style>
